import React, { Fragment, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

import FilterBlock from './FilterBlock';
import PackingControlBlock from './PackingControlBlock';

import Select from '../../common/Select';
import Button from '../../common/Button';
import { useDispatch, useSelector } from 'react-redux';
import { showModal } from '../../../actions/modal';
import { TAG_COLORS } from '../../../config';
import isMobile from 'ismobilejs';
import { fetchRefreshAllReserves } from '../../../actions/orders';
import { toast } from 'react-toastify';
import { useAutoTranslation } from '../../../helpers/useAutoTranslation';

const FiltersRow = (props) => {
  const {
    orders,
    search,
    statusesLength,
    selected,
    selectedLength,
    showFilter,
    activeTab,
    unpackingOrders,
    unpackingFilter,
    packingControlOrders,
    packingControlFilter,
    loadingReport,
    warehouses,
    activeWarehouse,
    setActiveWarehouse,
    handleSearch,
    setShowFilter,
    hideAddNewButton,
    handleCloseFilter,
    handleSetFilters,
    handleSetUnpackingFilter,
    handleSetControlPacking,
    handleShippingOrders,
    handleNewOrder,
    updateOrders,
    updateStatuses,
    history,
    filterFormInitial,
    setFilterFormInitial,
    loading,
    filters,
    exportType = 'standard',
  } = props;

  const dispatch = useDispatch();
  const { tags } = useSelector((state) => state.orders);

  const { t } = useAutoTranslation();

  const [tagsFilter, setTagsFilter] = useState(filters.tags ? filters.tags.split(`,`) : []);
  const [showActionsDropdown, setShowActionsDropdown] = useState(false);

  useEffect(() => {
    if (tagsFilter.length || filters.tags) {
      handleSetFilters({ ...filters, tags: tagsFilter.join(`,`) });
    }
  }, [tagsFilter]);

  const shippingOrders =
    activeTab === 'equipment' &&
    (selectedLength > 0
      ? orders.filter((o) => o.status === 'ORDER_INFO_PACKED' && selected[o.id])
      : []);
  const shippingOrdersLength =
    activeTab === 'equipment' &&
    (selectedLength > 0 ? shippingOrders.length : statusesLength.ORDER_INFO_PACKED);

  const handleClose = () => {
    history.replace();
    updateOrders();
  };

  const handleOpenTagsFilterModal = () => {
    dispatch(showModal(`TagsFilter`, { tagsFilter, setTagsFilter }));
  };

  const handleRefreshReserves = async () => {
    setShowActionsDropdown(false);
    dispatch(showModal(`RefreshReserves`, { finished: false }));
    try {
      const result = await dispatch(fetchRefreshAllReserves());
      await updateOrders();
      toast.info(
        `Обновление резервов выполнено. Обновлено заказов: ${
          result.planned + result.processed + result.reserved
        } шт.`,
      );
      result.errors.forEach((error) => toast.warn(error.message));
    } catch (e) {
      toast.error(`Ошибка обновления резервов`);
    }
    dispatch(showModal(`RefreshReserves`, { finished: true }));
  };

  return (
    <Fragment>
      {!packingControlFilter ? (
        <div className="row mb-2 filters-row">
          <div className="col-lg-3 form-wrapper">
            <form className="form-inline">
              <div className="form-group mb-2 orders-search-group">
                <label htmlFor="ordersSearch" className="sr-only">
                  Search
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="ordersSearch"
                  placeholder={t('Номер заказа, имя покупателя')}
                  value={search}
                  onChange={(e) => handleSearch(e.target.value)}
                />
                {history.location.state && history.location.state.reservedVariantId && (
                  <p className="reserved">
                    {t('Фильтр: "Заказы с резервом позиции')} –{' '}
                    {history.location.state.reservedVariantId},{' '}
                    {history.location.state.reservedVariantDescription}
                    <i className="fe-x" onClick={handleClose} />
                  </p>
                )}
                {!showFilter ? (
                  <button
                    type="button"
                    className="btn btn-primary btn-xs waves-effect waves-light"
                    onClick={() => setShowFilter(true)}
                  >
                    <i className="fe-sliders" />
                  </button>
                ) : null}
              </div>
            </form>
          </div>
          <div className="col-lg-9 extra-content">
            <Button
              className="tags-button btn-light"
              onClick={() => handleOpenTagsFilterModal()}
              text={
                <>
                  {t('Метки')}
                  {tagsFilter.length ? `:` : null}
                  {tags &&
                    tagsFilter.map((tag) => {
                      const currentColor = TAG_COLORS.find(
                        (item) => item.id === tags.find((item) => item.id === tag).color,
                      );
                      return (
                        <span className="tag-point" style={{ background: currentColor.code }} />
                      );
                    })}
                </>
              }
            />
            {activeTab === 'equipment' ? (
              <>
                <div
                  style={{
                    display: 'flex',
                    flex: '1 0 auto',
                    padding: '0 12px',
                  }}
                  className="packing-button-wrapper"
                >
                  {unpackingOrders ? (
                    <button
                      type="button"
                      style={{ marginLeft: '-12px' }}
                      className={`unpacking-button btn btn-light waves-effect waves-light mb-2 mr-2 ${
                        unpackingFilter ? 'active' : ''
                      }`}
                      onClick={handleSetUnpackingFilter}
                    >
                      {t(`Упаковка не начата`)}{' '}
                      <span className="badge badge-pill">
                        {statusesLength.ORDER_INFO_READY_TO_PACK}
                      </span>
                    </button>
                  ) : null}
                  {activeWarehouse.data.operatorType === 'MANUAL' && packingControlOrders ? (
                    <button
                      type="button"
                      className={`unpacking-button btn btn-light waves-effect waves-light mb-2 mr-2 ${
                        packingControlFilter ? 'active' : ''
                      }`}
                      onClick={handleSetControlPacking}
                    >
                      Контроль упаковки{' '}
                      <span className="badge badge-pill">
                        {statusesLength.ORDER_INFO_IN_PACKING}
                      </span>
                    </button>
                  ) : null}
                </div>
                <div style={{ display: `flex`, padding: '0 12px' }} className="select">
                  <div style={{ minWidth: '190px' }}>
                    <Select
                      options={warehouses.filter(
                        (warehouse) => warehouse.data.operationType === `STORAGE`,
                      )}
                      value={activeWarehouse}
                      onChange={(w) => setActiveWarehouse(w)}
                    />
                  </div>
                  {activeWarehouse.data.operatorType === 'MANUAL' && shippingOrdersLength ? (
                    <div className="text-lg-right">
                      <button
                        type="button"
                        style={{ marginLeft: '12px', minHeight: '38px' }}
                        className={`shipping-button btn btn-success waves-effect waves-light mb-2 mr-2`}
                        onClick={() => handleShippingOrders(shippingOrders)}
                      >
                        Отгрузка заказов{' '}
                        <span className="badge badge-pill">{shippingOrdersLength}</span>
                      </button>
                    </div>
                  ) : null}
                </div>
              </>
            ) : (
              <>
                {!hideAddNewButton ? (
                  <button
                    type="button"
                    className="btn btn-danger waves-effect waves-light mb-2 mr-2 new-order"
                    onClick={handleNewOrder}
                  >
                    <i className="fe-plus" />
                    <span>{t('Новый заказ')}</span>
                  </button>
                ) : null}
                <Link to="/orders-import" className="btn btn-light mb-2 mr-2">
                  <i className="fe-arrow-up" /> {t('Импорт')}
                </Link>
                <Link
                  to={`/orders-export?export_type=${exportType}`}
                  className="btn btn-light mb-2 mr-2"
                >
                  <i className="fe-arrow-down" /> {t('Экспорт')}
                </Link>
                {!isMobile().any && (
                  <div className="dropdown-wrapper">
                    <button
                      type="button"
                      className="btn btn-light dropdown-toggle mb-2 mr-2"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                      onClick={() => setShowActionsDropdown(!showActionsDropdown)}
                      style={{ width: 35, padding: `7px` }}
                    >
                      <i className="fe-more-vertical" />
                    </button>
                    <div
                      className={`dropdown-menu ${showActionsDropdown ? `show` : ``}`}
                      style={{ left: `unset`, right: 0, cursor: `pointer` }}
                    >
                      <div className="dropdown-item" onClick={handleRefreshReserves}>
                        {t('Обновить резервы заказов')}
                      </div>
                    </div>
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      ) : (
        <PackingControlBlock
          packingControlOrders={packingControlOrders}
          handleCloseControlBlock={handleSetControlPacking}
          updateOrders={updateOrders}
          updateStatuses={updateStatuses}
        />
      )}
      {showFilter ? (
        <FilterBlock
          handleCloseFilter={handleCloseFilter}
          handleSetFilters={handleSetFilters}
          filterFormInitial={filterFormInitial}
          loading={loading}
          setFilterFormInitial={setFilterFormInitial}
        />
      ) : null}
    </Fragment>
  );
};

export default FiltersRow;
